"use client";

import Link from "next/link";
import { BridgeLayout } from "@/components/bridge";
import { BridgeActivity } from "@/components/bridge/activity";
import { GridDotPattern, InfoIcon, HyperLinkIcon } from "@/icons";

export default function BridgePage() {
  return (
    <div className="flex w-full flex-col pb-6 md:pb-8">
      <div className="relative flex w-full flex-col">
        {/* Background Pattern - Hidden on mobile */}
        <div className="absolute hidden w-full flex-col lg:flex">
          <div className="relative flex w-full flex-col">
            <div className="relative flex w-full flex-row items-center justify-between pb-36 opacity-70">
              <div className="absolute -top-8 -left-8">
                <GridDotPattern />
              </div>
              <div className="absolute -top-8 -right-8 rotate-90">
                <GridDotPattern />
              </div>
            </div>
          </div>
        </div>

        {/* Hero Section */}
        <div className="z-1 flex w-full flex-col px-4 pt-6 md:px-8 lg:mt-12 lg:px-0">
          <div className="mx-auto flex w-full max-w-6xl flex-col items-start justify-start gap-4 lg:px-[76px]">
            <h1 className="font-sans-serif text-3xl font-medium -tracking-[0.3px] sm:text-4xl md:text-5xl lg:text-[34.25px]">
              <span>{`Bridge onto `}</span>
              <span className="text-[#FF6D01]">Camp</span>
            </h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="z-20 mx-auto mt-8 flex w-full max-w-6xl flex-col p-4 md:p-8 lg:px-[76px]">
          <div className="grid w-full grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
            {/* Bridge Section */}
            <div className="flex w-full flex-col gap-4">
              <h2 className="font-sans-serif text-xl font-semibold -tracking-[0.3px] text-[#1A1A1A] sm:text-2xl">
                Bridge
              </h2>
              <BridgeLayout />
              <Link
                href="https://docs.campnetwork.xyz/introduction/l1-architecture/bridging"
                target="_blank"
                className="group flex flex-row items-start gap-1.5 sm:items-center">
                <InfoIcon />
                <span className="font-sans-serif text-sm font-normal text-[#838383]">
                  Please refer to our docs for any questions around bridging
                </span>
                <span className="shrink-0 group-hover:scale-95">
                  <HyperLinkIcon color="#838383" />
                </span>
              </Link>
            </div>

            {/* Activity Section */}
            <div className="flex w-full flex-col gap-4">
              <h2 className="font-sans-serif text-xl font-semibold -tracking-[0.3px] text-[#1A1A1A] sm:text-2xl">
                Your Activity
              </h2>
              <BridgeActivity />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
